var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('el-alert',{attrs:{"title":"登录超时提醒","type":"error","description":"请刷新页面重新登录系统","show-icon":""}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }